import flatten from 'lodash/flatten';
import some from 'lodash/some';

function shouldBeShownToPayColumn(payoutSystem, rows) {
	const payouts = flatten(rows.map(row => row.payouts));
	return !!Number(payoutSystem.payout_percent)
		|| some(payouts, payout => !!Number(payout.payout_percent))
		|| !!Number(payoutSystem.payout_fee)
		|| some(payouts, payout => !!Number(payout.payout_fee));
}

export default shouldBeShownToPayColumn;


// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/payouts/components/table/helpers/should-be-shown-to-pay-column.js